// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__lbtX3","noPadding":"Section_noPadding__0Cz0S","smallPaddingTop":"Section_smallPaddingTop__BtPXZ"};